module.exports = __webpack_public_path__ + "static/media/tech-removebg-preview.79d7c8b6.png";